var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEditCircle = function SvgEditCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 16.328A7.97 7.97 0 0 1 .031 8.36 7.97 7.97 0 0 1 8 .391a7.97 7.97 0 0 1 7.969 7.968A7.97 7.97 0 0 1 8 16.33M8 15a6.635 6.635 0 0 0 6.64-6.64A6.635 6.635 0 0 0 8 1.718a6.635 6.635 0 0 0-6.64 6.64A6.635 6.635 0 0 0 8 15m3.086-8.828-.922-.93.57-.562c.25-.25.54-.274.774-.04l.18.18c.234.235.21.516-.04.782zm-5.594 5.57-1.078.406a.223.223 0 0 1-.281-.296l.445-1.04 5.117-5.101.922.922z"
  })));
};
export default SvgEditCircle;